export enum WorkingDayFormSection {
    Basic = 'BASIC',
    Breaks = 'BREAKS'
};

export enum WorkingDayFormOrigin {
    Table = 'TABLE',
    Errors = 'ERRORS'
};
